
export * from '../../frontend-js-dependencies-web/__liferay__/exports/text-mask-addons.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/text-mask-addons.js';
export default __default__;
